'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var Tracer = require('opentracing').Tracer;

var Scope = require('../scope/base');

var Span = require('./span');

var platform = require('../platform');

var NoopTracer =
/*#__PURE__*/
function (_Tracer) {
  _inherits(NoopTracer, _Tracer);

  function NoopTracer(config) {
    var _this;

    _classCallCheck(this, NoopTracer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NoopTracer).call(this, config));
    var ScopeManager;

    if (platform.env('DD_CONTEXT_PROPAGATION') === 'false') {
      ScopeManager = require('../scope/noop/scope_manager');
    } else {
      ScopeManager = require('../scope/scope_manager');
    }

    _this._scopeManager = new ScopeManager();
    _this._scope = new Scope(config);
    _this._span = new Span(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NoopTracer, [{
    key: "trace",
    value: function trace(name, options, fn) {
      return fn(this._span, function () {});
    }
  }, {
    key: "wrap",
    value: function wrap(name, options, fn) {
      return fn;
    }
  }, {
    key: "scopeManager",
    value: function scopeManager() {
      return this._scopeManager;
    }
  }, {
    key: "scope",
    value: function scope() {
      return this._scope;
    }
  }, {
    key: "currentSpan",
    value: function currentSpan() {
      return null;
    }
  }, {
    key: "_startSpan",
    value: function _startSpan(name, options) {
      return this._span;
    }
  }]);

  return NoopTracer;
}(Tracer);

module.exports = NoopTracer;